import styled from 'styled-components'
import { Button, ResponsiveImage } from '@bm-js/atlascloud-ui'
import { colors } from '../utils/config'
import { FileEntryBM } from '@bm-js/atlascloud-shared'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { useMedia } from '../utils/hooks'

const StyledImageInput = styled.div`
  .file-selector-image-container {
    max-width: 200px;
    margin-bottom: 0.5rem;
  }
  margin-bottom: 1rem;
  label,
  span {
    display: block;
  }
  label {
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
    color: ${colors.gray700};
    font-weight: 500;
  }
  span {
    font-family: 'Inter', sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${colors.gray600};
    margin-bottom: 0.4rem;
  }
`

type Props = {
  onChange: (file?: FileEntryBM) => void
  file?: FileEntryBM | null
  label?: string
  desc?: string
  id?: string
}

const ImageInput = ({ onChange, file, label, desc, id }: Props) => {
  const { tr } = useTr()
  const { openMediaSelector, closeMediaSelector } = useMedia()

  return (
    <StyledImageInput>
      {label && <label htmlFor={id}>{label}</label>}
      {desc && <span>{desc}</span>}
      <div className='file-selector-image-container'>
        {file ? <ResponsiveImage file={file} /> : null}
      </div>
      <Button
        onClick={() =>
          openMediaSelector({
            fileType: 'image',
            onSelect: (f) => {
              if (!f) return closeMediaSelector()
              onChange(f)
              closeMediaSelector()
            },
          })
        }
      >
        {file
          ? tr(TrKey.imageInputChangeImage)
          : tr(TrKey.imageInputSelectImage)}
      </Button>
    </StyledImageInput>
  )
}

export default ImageInput
